import debounce from "../utils/debounce";
import localizedData from "./localizedData";

( () => {
	const jobOfferingFilterForm = document.querySelector<HTMLFormElement>(
		'form[data-ufr-advanced-filter="job_offering"]' );
	const jobOfferingList = document.querySelector<HTMLUListElement>(
		'ul[data-ufr-filtered-list="job_offering"]' );

	if ( !jobOfferingFilterForm || !jobOfferingList ) {
		return;
	}

	const searchInputField = jobOfferingFilterForm.querySelector<HTMLInputElement>(
		'input[data-type="search"]' );

	const handleJobFilterChange = async ( event?: InputEvent ) => {

		// If the event is triggered by the list-view checkbox, do nothing as no filter was changed.
		if ( event && event.target instanceof HTMLInputElement && event.target.name === 'list-view' ) {
			return;
		}

		const selectedCheckboxes = Array.from( jobOfferingFilterForm.querySelectorAll<HTMLInputElement>(
			'input[type="checkbox"]:checked' ) );

		const selectedCategories = selectedCheckboxes.map( ( checkbox ) => {
			return checkbox.name.split( '|' )[2];
		} );

		const formData = new FormData( jobOfferingFilterForm );

		const currentFilters = {
			search_term: searchInputField?.value ?? '',
			categories: ( selectedCategories ?? [] ).join( ',' ),
			order_by: formData.get( 'orderby' ).toString() ?? 'bewerbungsstart',
			sort_direction: formData.get( 'sort_direction' ).toString() ?? 'DESC',
			current_blog_url : window.location.href,
		};

		const queryParams = new URLSearchParams( currentFilters );
		const menuApiUri = localizedData.menuApiUriData.home_url;
		const url = `${menuApiUri}/wp-json/wp/v2/job-offerings?${queryParams}`;

		const response = await fetch( url );

		// If the response is not ok, throw an error
		if ( !response.ok ) {
			throw new Error( `An error occurred: ${response.statusText}` );
		}

		// response.body contains fully rendered-out HTML markup, set jobOfferingList's innerHTML to it.
		jobOfferingList.innerHTML = await response.text();
	};

	// Check if any input inside the form changed and attach an event listener to it
	jobOfferingFilterForm.addEventListener( 'input', debounce( handleJobFilterChange, 200 ) );
	jobOfferingFilterForm.addEventListener( 'submit', ( event ) => {
		event.preventDefault();
	} );

	handleJobFilterChange();

} )();
